import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";
import { Building2, CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const { t } = useApp();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");   // checking | success | active | error

  useEffect(() => {
    const id = params.get("id");
    const token = params.get("token");
    if (!id || !token) { setState("error"); return; }
    api.post("/auth/verify-email", { id, token })
      .then(({ data }) => setState(data.status === "active" ? "active" : "success"))
      .catch(() => setState("error"));
  }, [params]);

  const cfg = {
    checking: { icon: <Loader2 className="h-9 w-9 animate-spin" />, title: t("verify_checking"), msg: "" },
    success: { icon: <CheckCircle2 className="h-9 w-9" />, title: t("verify_success_title"), msg: t("verify_success_msg") },
    active: { icon: <CheckCircle2 className="h-9 w-9" />, title: t("verify_success_title"), msg: t("verify_already_active") },
    error: { icon: <XCircle className="h-9 w-9" />, title: t("verify_error_title"), msg: t("verify_error_msg") },
  }[state];

  return (
    <div className="min-h-screen bg-brand text-white relative overflow-hidden flex flex-col items-center justify-center px-6" data-testid="verify-email-page">
      <div className="absolute inset-0 zellige-overlay pointer-events-none" />
      <div className="relative z-10 max-w-md w-full text-center">
        <div className="h-16 w-16 rounded-2xl bg-white/15 flex items-center justify-center mb-6 mx-auto">
          {cfg.icon}
        </div>
        <div className="flex items-center justify-center gap-2 mb-2 text-white/60">
          <Building2 className="h-4 w-4" /><span className="text-sm font-semibold">Rahma Bât A</span>
        </div>
        <h1 className="text-3xl font-black mb-3" data-testid="verify-title">{cfg.title}</h1>
        {cfg.msg && <p className="text-white/80 text-base mb-8">{cfg.msg}</p>}
        {state !== "checking" && (
          <button onClick={() => navigate("/login")} data-testid="verify-goto-login"
            className="w-full h-14 rounded-2xl bg-majorelle text-white font-bold text-lg mt-4">
            {t("back_to_login")}
          </button>
        )}
      </div>
    </div>
  );
}
